import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Broker from 'bundles/apex/deals/show/brokers/broker';
import UserIcon from 'components/user_icon';
import { filterCommissions } from 'bundles/backoffice/vouchers/helpers/commissions';

export function TransactionSideCardInternalCommissions({ deal, transactionSide }) {
  const internalCommissions = deal.commissions.filter(commission => !commission.outside);
  const commissions = filterCommissions(internalCommissions, transactionSide, false);

  if (!commissions.length) {
    return null;
  }

  return <React.Fragment>
    <b className="mb-3">Internal Brokers</b>
    {commissions.map((commission, i) => (
      <Broker
        commission={commission}
        deletable={internalCommissions.length > 1}
        icon={<UserIcon user={deal.brokers.find(broker => broker.id === commission.broker.id)} />}
        index={i}
        justify={false}
        key={i}
        transactionSide={transactionSide}
      >
        <div className="flex-1 px-4">
          <div className="text-muted">
            {i === 0 && 'Primary'} Broker
          </div>

          {commission.broker.name}
        </div>
      </Broker>
    ))}
  </React.Fragment>;
}

TransactionSideCardInternalCommissions.propTypes = {
  deal: PropTypes.shape({
    commissions: PropTypes.arrayOf(PropTypes.shape({
      outside: PropTypes.bool,
      transactionSide: PropTypes.string,
    })).isRequired,
  }).isRequired,
  transactionSide: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(TransactionSideCardInternalCommissions);
